import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { Alert, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import CheckIcon from '@mui/icons-material/Check';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useInput } from '../../lib/index.js';

export default function EditTagModal({ moment, userId, setPendingTagChange }) {
  const [open, setOpen] = useState(false);
  const [editTagError, setEditTagError] = useState(null);
  const { t } = useTranslation();
  const [newMomentNameValue, handleNewMomentNameValue, setNewMomentNameValue] = useInput("")

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNewMomentNameValue("")
    setEditTagError(null)
  };

  const handleEditTag = async (moment) => {
    try {
      const momentDocRef = doc(db, 'users', userId, 'moments', moment.id);
      await updateDoc(momentDocRef, {
        name: newMomentNameValue,
      });
      setOpen(false)
      setPendingTagChange(true)
    } catch (error) {
      setEditTagError(t('editTags.error'))
    }
  }

  const handleDeleteTag =  async () => {
    try {
      const momentsDocRef = doc(db, 'users', userId, 'moments', moment.id)
      await deleteDoc(momentsDocRef)
      setPendingTagChange(true)
      setOpen(false)
      console.log("borrado en firebase")
    } catch (error) {
      console.log("error borrando en firebase", error)
    }
  };

  return (
    <div>
      <IconButton
        sx={{ color: 'black' }}
        onClick={handleClickOpen}
      >
        <EditIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ display: 'flex', alignItems: 'center' }}>
          <DialogContentText id="alert-dialog-description">
            <TextField
              id={moment.name}
              label="Tag Name"
              defaultValue={moment.name}
              variant="standard"
              onChange={handleNewMomentNameValue}
            />
          </DialogContentText>
          <Button onClick={() => handleEditTag(moment)}><CheckIcon /></Button>
        </DialogContent>
        {editTagError != null &&
          <Alert severity="error">{editTagError}</Alert>
        }
        <DialogActions>
          <Button  onClick={handleDeleteTag}>Delete</Button>
          <Button onClick={handleClose} variant="contained" autoFocus color="primary">
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}